module.exports = __webpack_public_path__ + "img/bg-search.dd255a41.jpg";